<template>
  <div class="dashboard__wrapper" :class="routeName">
    <div class="dashboard__wrapper-inner">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardLayout',

  computed: {
    routeName() {
      return this.$route.name
    },
  },
}
</script>

<style scoped></style>
